
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export interface PollWidgetNavigationProps {
  currentIndex: number;
  totalPolls: number;
  onNext: () => void;
  onPrevious: () => void;
}

const PollWidgetNavigation: React.FC<PollWidgetNavigationProps> = ({
  currentIndex,
  totalPolls,
  onNext,
  onPrevious
}) => {
  return (
    <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-100 dark:border-gray-800">
      <Button
        variant="outline"
        size="sm"
        onClick={onPrevious}
        disabled={currentIndex === 0}
      >
        <ChevronLeft className="h-4 w-4 mr-1" />
        Previous
      </Button>
      
      <span className="text-sm text-muted-foreground">
        {currentIndex + 1} of {totalPolls}
      </span>
      
      <Button
        variant="outline"
        size="sm"
        onClick={onNext}
        disabled={currentIndex === totalPolls - 1}
      >
        Next
        <ChevronRight className="h-4 w-4 ml-1" />
      </Button>
    </div>
  );
};

export default PollWidgetNavigation;
